import { CostCompareCards } from "@/components/trip-planner/CostCompareCards";
import { DeltaAirportCard } from "@/components/trip-planner/DeltaAirportCard";
import { DistanceCard } from "@/components/trip-planner/DistanceCard";
import { HotelList } from "@/components/trip-planner/HotelList";
import type { TripPlannerResponse } from "@/types/tripPlanner";

export interface ResultsSectionProps {
  data: TripPlannerResponse;
}

export function ResultsSection({ data }: ResultsSectionProps): React.ReactElement {
  return (
    <div className="flex flex-col gap-4">
      {data.distance_miles > 2500 && (
        <div className="rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
          Very long drive — fly is strongly recommended.
        </div>
      )}
      <DistanceCard miles={data.distance_miles} minutes={data.drive_minutes} originLabel={data.origin.label} />
      <CostCompareCards costs={data.costs} />
      <HotelList hilton={data.hotels.hilton} comparable={data.hotels.comparable} />
      <DeltaAirportCard airports={data.nearest_delta} />
    </div>
  );
}
